import { render } from "./SharedShioriView.vue?vue&type=template&id=616a70b5&scoped=true"
import script from "./SharedShioriView.vue?vue&type=script&lang=js"
export * from "./SharedShioriView.vue?vue&type=script&lang=js"

import "./SharedShioriView.vue?vue&type=style&index=0&id=616a70b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616a70b5"]])

export default __exports__